
/**
 * @function v3sArea
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * 
 * # Area
 * Eine Fläche kann definiert werden. Diese kann verschiedene Typen haben. Auf der Area können Ereignisse gebunden werden.
 */

angular.module('v3sWbtPlayerApp').directive('v3sArea', function () {
    return {
        restrict: 'E',
        transclude: true,
        require : '^v3sDocument',
        scope: {
            id: '@',
            v3sType: '@',
            v3sName: '@'
        },
        link: function (scope, element, attrs, docCtrl) {
            if (!!scope.id) {
                docCtrl.addElement(element);
            }
        }

    }
});
